import QuantityController from "./QuantityController";

export default QuantityController
